import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import {
  refreshUnitAsync,
  fetchUnitsAsync,
  getUnit,
  getUnits,
  getTest,
  adminGetUnit,
  setUnit,
  getSurvey,
  fetchUnitAdminAsync,
  getCourse,
  getUnitsError,
  setUnitsErrorAsync,
} from 'store/units/index';
import { handleToastError } from 'helpers';

import useI18n from '../use-i18n';

export const useCourse = () => {
  const course = useSelector(getCourse);
  return course;
};

export const useUnit = () => {
  const unit = useSelector(getUnit);
  return unit;
};

export const useUnits = () => {
  const units = useSelector(getUnits);
  return units;
};

export const useTest = () => {
  const test = useSelector(getTest);
  return test;
};

export const useSurvey = () => {
  const survey = useSelector(getSurvey);
  return survey;
};

export const useUnitsError = () => useSelector(getUnitsError);

export const useFetchUnit = () => {
  const dispatch = useDispatch();
  const {
    query: { unitId },
  } = useRouter();

  useEffect(() => {
    const callApi = async () => {
      try {
        await dispatch(refreshUnitAsync(unitId));
      } catch (e) {
        await dispatch(
          setUnitsErrorAsync({
            data: e?.response?.data,
            status: e?.response?.status,
          }),
        );
      }
    };
    callApi();
  }, [unitId]);
};

export const useFetchAdminUnitId = () => {
  const i18n = useI18n();
  const dispatch = useDispatch();
  const {
    back,
    query: { unitId },
  } = useRouter();

  useEffect(() => {
    const callApi = async () => {
      try {
        dispatch(setUnit(undefined));
        await dispatch(fetchUnitAdminAsync(unitId));
      } catch (e) {
        back();
        handleToastError(e, i18n);
      }
    };

    callApi();
  }, []);
};

export const useAdminFetchUnit = () => {
  const i18n = useI18n();
  const dispatch = useDispatch();
  const {
    back,
    query: { id },
  } = useRouter();

  useEffect(() => {
    const callApi = async () => {
      try {
        dispatch(setUnit(undefined));
        await dispatch(adminGetUnit(id));
      } catch (e) {
        back();
        handleToastError(e, i18n);
      }
    };

    callApi();
  }, []);
};

export const useFetchUnits = (vl) => {
  const dispatch = useDispatch();
  const {
    query: { slug },
  } = useRouter();

  useEffect(() => {
    const callApi = async () => {
      try {
        await dispatch(fetchUnitsAsync(slug, vl));
      } catch (e) {
        await dispatch(
          setUnitsErrorAsync({
            data: e?.response?.data,
            status: e?.response?.status,
          }),
        );
      }
    };

    callApi();
  }, [slug]);
};
